import React__default from 'react';
import { CommonStyles } from '../BaseProps/index.es.js';
import { SvgCss } from '@teko/ds-icon';
import { BUTTON_CONFIG } from './constant.es.js';
import { ButtonShapeEnum } from '@teko/types/ds';
import { Body, Caption } from '../Typography/index.es.js';
import { SizeContext } from '../../contexts/SizeContext.es.js';
import { Ripple } from '../Ripple/Ripple.es.js';
import styled from '@emotion/styled';
import { css } from '@emotion/react';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const buttonStyleByVariant = (props) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _A, _B, _C, _D, _E, _F;
  switch (props.variant) {
    case "default": {
      return css`
        background-color: transparent;
        border: 1px solid
          ${props.disabled ? (_a = props.theme) == null ? void 0 : _a.colors.disable : (_b = props.theme) == null ? void 0 : _b.colors.border};
        ${!props.disabled ? `&:hover {
          border-color: ${(_c = props.theme) == null ? void 0 : _c.colors.textSecondary};
        }
        &:active {
          border-color: ${(_d = props.theme) == null ? void 0 : _d.colors.textPrimary};
          path[stroke],
          rect[stroke],
          line {
            stroke: ${(_e = props.theme) == null ? void 0 : _e.colors.textPrimary};
          }
          path:not([stroke]),
          rect:not([stroke]) {
            fill: ${(_f = props.theme) == null ? void 0 : _f.colors.textPrimary};
          }
        }` : ""}
      `;
    }
    case "ghost": {
      return css`
        background-color: ${(_g = props.theme) == null ? void 0 : _g.colors.white};
        border: 1px solid
          ${props.disabled ? (_h = props.theme) == null ? void 0 : _h.colors.disable : (_i = props.theme) == null ? void 0 : _i.colors.border};
        ${!props.disabled ? `&:hover {
          border-color: ${(_j = props.theme) == null ? void 0 : _j.colors.textSecondary};
        }
        &:active {
          border-color: ${(_k = props.theme) == null ? void 0 : _k.colors.textPrimary};
          path[stroke],
          rect[stroke],
          line {
            stroke: ${(_l = props.theme) == null ? void 0 : _l.colors.textPrimary};
          }
          path:not([stroke]),
          rect:not([stroke]) {
            fill: ${(_m = props.theme) == null ? void 0 : _m.colors.textPrimary};
          }
        }` : ""}
      `;
    }
    case "secondary": {
      return css`
        background-color: ${(_n = props.theme) == null ? void 0 : _n.colors.white};
        border: 1px solid
          ${props.disabled ? (_o = props.theme) == null ? void 0 : _o.colors.disable : (_p = props.theme) == null ? void 0 : _p.colors.primary500};
        ${!props.disabled ? `
          &:hover {
            border-color: ${(_q = props.theme) == null ? void 0 : _q.colors.primary600};
            div[type=body] {
              color: ${(_r = props.theme) == null ? void 0 : _r.colors.primary600};
            }
            path[stroke],
            rect[stroke],
            line {
              stroke: ${(_s = props.theme) == null ? void 0 : _s.colors.primary600};
            }
            path:not([stroke]),
            rect:not([stroke]) {
              fill: ${(_t = props.theme) == null ? void 0 : _t.colors.primary600};
            }
          }
          &:active {
            border-color: ${(_u = props.theme) == null ? void 0 : _u.colors.primary700};
            div[type=body] {
              color: ${(_v = props.theme) == null ? void 0 : _v.colors.primary700};
            }
            path[stroke],
            rect[stroke],
            line {
              stroke: ${(_w = props.theme) == null ? void 0 : _w.colors.primary700};
            }
            path:not([stroke]),
            rect:not([stroke]) {
              fill: ${(_x = props.theme) == null ? void 0 : _x.colors.primary700};
            }
          }
        ` : ""}
      `;
    }
    case "white-ghost": {
      return css`
        background-color: ${(_y = props.theme) == null ? void 0 : _y.colors.white};
        border: none;
        ${props.disabled ? `
          background-color: ${(_z = props.theme) == null ? void 0 : _z.colors.disable};
          ` : `
          &:hover {
            background-color: ${(_A = props.theme) == null ? void 0 : _A.colors.tableHeader};
          }
          &:active {
            background-color: ${(_B = props.theme) == null ? void 0 : _B.colors.background};
          }
        `}
      `;
    }
    case "primary":
    default:
      return css`
        background-color: ${props.disabled ? (_C = props.theme) == null ? void 0 : _C.colors.disable : (_D = props.theme) == null ? void 0 : _D.colors.primary500};
        ${!props.disabled ? `
          &:hover {
            background-color: ${(_E = props.theme) == null ? void 0 : _E.colors.primary600};
          }
          &:active {
            background-color: ${(_F = props.theme) == null ? void 0 : _F.colors.primary700};
          }
        ` : ""}
      `;
  }
};
const buttonShapeStyle = ({ theme, shape, size }) => {
  switch (shape) {
    case ButtonShapeEnum.round:
      return css`
        border-radius: ${parseFloat(BUTTON_CONFIG.height[size || "m"].slice(0, -3)) / 2}rem
          ${parseFloat(BUTTON_CONFIG.height[size || "m"].slice(0, -3)) / 2}rem;
      `;
    case ButtonShapeEnum.circle:
      return css`
        border-radius: 50%;
      `;
    default:
      return css`
        border-radius: ${theme == null ? void 0 : theme.borderRadius.s};
      `;
  }
};
const Button = (_a) => {
  var _b = _a, {
    children,
    block = false,
    shape,
    size: customizeSize,
    variant = "default",
    prefix,
    suffix,
    disabled,
    onClick,
    className,
    href,
    type = "button",
    backgroundColor
  } = _b, rest = __objRest(_b, [
    "children",
    "block",
    "shape",
    "size",
    "variant",
    "prefix",
    "suffix",
    "disabled",
    "onClick",
    "className",
    "href",
    "type",
    "backgroundColor"
  ]);
  const size = React__default.useContext(SizeContext);
  const mergeSize = customizeSize || size || "m";
  const handleClick = (e) => {
    if (disabled) {
      e.preventDefault();
      return;
    }
    onClick == null ? void 0 : onClick(e);
  };
  if (variant === "link") {
    return /* @__PURE__ */ React__default.createElement(StyledLink, __spreadValues({
      href,
      target: "_blank",
      rel: "noopener noreferrer",
      className,
      itemHorizontalSpacing: "s4",
      color: disabled ? BUTTON_CONFIG.disabled.iconColor.link : BUTTON_CONFIG.iconColor.link,
      onClick: handleClick,
      disabled: !!disabled
    }, rest), prefix ? /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, prefix, /* @__PURE__ */ React__default.createElement(Spacer, null)) : void 0, children && typeof children === "string" ? mergeSize === "m" ? /* @__PURE__ */ React__default.createElement(Body, {
      className: "button-text",
      level: 1,
      color: disabled ? BUTTON_CONFIG.disabled.textColor.link : BUTTON_CONFIG.textColor.link
    }, children) : /* @__PURE__ */ React__default.createElement(Caption, {
      className: "button-text",
      level: 1,
      color: disabled ? BUTTON_CONFIG.disabled.textColor.link : BUTTON_CONFIG.textColor.link
    }, children) : children, suffix ? /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(Spacer, null), suffix) : void 0);
  }
  return /* @__PURE__ */ React__default.createElement(StyledButton, __spreadValues({
    height: BUTTON_CONFIG.height[mergeSize],
    padding: shape !== "circle" ? ["s0", "s20"] : void 0,
    itemHorizontalSpacing: "s8",
    color: variant === "default" ? void 0 : disabled ? BUTTON_CONFIG.disabled.iconColor[variant] : BUTTON_CONFIG.iconColor[variant],
    backgroundColor,
    variant,
    disabled: !!disabled,
    block,
    shape,
    size: mergeSize,
    onClick: handleClick,
    className,
    type
  }, rest), prefix ? /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, prefix, /* @__PURE__ */ React__default.createElement(Spacer, null)) : void 0, children && typeof children === "string" ? /* @__PURE__ */ React__default.createElement(Body, {
    className: "button-text",
    level: mergeSize === "s" ? 2 : 1,
    color: variant === "default" ? void 0 : disabled ? BUTTON_CONFIG.disabled.textColor[variant] : BUTTON_CONFIG.textColor[variant]
  }, children) : children, suffix ? /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(Spacer, null), suffix) : void 0, /* @__PURE__ */ React__default.createElement("span", {
    style: { marginLeft: 0 }
  }, /* @__PURE__ */ React__default.createElement(Ripple, null)));
};
const Spacer = styled.span`
  width: 0.5rem;
`;
const StyledButton = styled.button(({
  height,
  theme,
  color,
  block,
  disabled,
  backgroundColor
}) => [
  CommonStyles,
  SvgCss,
  buttonShapeStyle,
  buttonStyleByVariant,
  `position: relative;
display: flex;
align-items: center;
justify-content: center;
outline: none;
min-width: ${height};
${color ? `color: ${(theme == null ? void 0 : theme.colors[color]) || color};` : ""}
${block ? `width: 100%;` : ""}
cursor: ${disabled ? "not-allowed" : "pointer"};
${backgroundColor ? `background-color: ${(theme == null ? void 0 : theme.colors[backgroundColor]) || backgroundColor} !important;` : ""}
transition-duration: 80ms;
transition-property: background-color;
&:focus {
  outline: none;
}
`
]);
const StyledLink = styled.a`
  ${CommonStyles}
  ${SvgCss}
  display: inline;
  cursor: ${(p) => p.disabled ? "not-allowed" : "pointer"};
  ${(p) => {
  var _a;
  return p.color ? `color: ${((_a = p.theme) == null ? void 0 : _a.colors[p.color]) || p.color}!important;` : "";
}}
  text-decoration: none;
  ${(p) => !p.disabled ? `
    &:hover {
      text-decoration: underline;
    }
    
  div {
    display: inline;
  }
  ` : ""}
`;

export { Button };
